export class Help {

    table: string;
    content: {};

    popup(field: string) {
        return Object.keys(this.content).filter( aField => (aField === field)).map( aField => this.content[aField])[0];
    }
}